const conveniosPaciente = [
  {
    id: 1,
    label: '4) Convênio do paciente',
    name: 'convenio_avc',
    opcoes: [
      {
        id: 1,
        descricao: 'Operadoras de saúde',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Particular',
        value: '2',
      },
      {
        id: 3,
        descricao: 'SUS',
        value: '3',
      },
    ],
  },
];

const tiposDeAvc = [
  {
    id: 1,
    label: '5) Tipo de AVC',
    name: 'classificacao_avc',
    opcoes: [
      {
        id: 1,
        descricao: 'AVC isquêmico (AVCi)',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Ataque isquêmico transitório (AIT)',
        value: '2',
      },
      {
        id: 3,
        descricao: 'AVC hemorrágico (AVCh)',
        value: '3',
      },
      {
        id: 4,
        descricao: 'Suspeita não-confirmada de AVC',
        value: '4',
      },
    ],
  },
];

const examesDeImagem = [
  {
    id: 1,
    label: '6) Exame de imagem realizado',
    name: 'ex_imagem_avc',
    opcoes: [
      {
        id: 1,
        descricao: 'Tomografia computadorizada de crânio',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Ressonância magnética de crânio',
        value: '2',
      },
      {
        id: 3,
        descricao: 'Tomografia computadorizada e ressonância magnética',
        value: '3',
      },
      {
        id: 4,
        descricao: 'Nenhum dos dois',
        value: '0',
      },
    ],
  },
];

const tempoInicioSintomas = [
  {
    id: 1,
    label: 'Data do início dos sintomas de AVC',
    name: 'sintomas_data_avc',
  },
  {
    id: 2,
    label: 'Hora do início dos sintomas de AVC',
    name: 'sintomas_hora_avc',
  },
];

const tromboliseIntravenosa = [
  {
    id: 1,
    label: 'Data da realização da trombólise intravenosa',
    name: 'trombolise_data_avc',
  },
  {
    id: 2,
    label: 'Hora da realização da trombólise intravenosa',
    name: 'trombolise_hora_avc',
  },
];

const trombectomia = [
  {
    id: 1,
    label: 'Data da realização da trombectomia mecânica',
    name: 'trombectomia_data_avc',
  },
  {
    id: 2,
    label: 'Hora da realização da trombectomia mecânica',
    name: 'trombectomia_hora_avc',
  },
];

const chegadaEmergencia = [
  {
    id: 1,
    label: 'Data da chegada na emergência',
    name: 'emergencia_data_avc',
  },
  {
    id: 2,
    label: `Hora da chegada na emergência`,
    name: 'emergencia_hora_avc',
  },
];

const saidaEmergencia = [
  {
    id: 1,
    label: 'Data da alta/óbito',
    name: 'saida_data_avc',
  },
  {
    id: 2,
    label: `Hora da alta/óbito`,
    name: 'saida_hora_avc',
  },
];

const atendimentoDuranteInternacao = [
  {
    id: 1,
    label: 'a) Unidade vascular',
    name: 'local_avc_uni_vasc',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 2,
    label: `b) Emergência geral`,
    name: 'local_avc_emer_geral',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 3,
    label: `c) Neuro UTI`,
    name: 'local_avc_uti_neuro',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 4,
    label: 'd) UTI geral',
    name: 'local_avc_uti_geral',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 5,
    label: `e) Unidade de AVC`,
    name: 'local_avc_uni_avc',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 6,
    label: `f) Enfermaria geral`,
    name: 'local_avc_enf_geral',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];

const tratamentoReperfusao = [
  {
    id: 1,
    label: 'a) Trombólise intravenosa',
    name: 'reperfusao_avc_tiv',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 2,
    label: `b) Trombólise intra-arterial`,
    name: 'reperfusao_avc_tia',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 3,
    label: `c) Trombectomia mecânica`,
    name: 'reperfusao_avc_trombec',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];

const flutterAtrial =[
  {
     id: 1,
     label:
       '14) Diagnóstico de fibrilação atrial ou flutter atrial durante a internação',
     name: 'fa_avc',
     opcoes: [
       {
         id: 1,
         descricao: 'Sim',
         value: '1',
       },
       {
         id: 2,
         descricao: 'Não',
         value: '0',
       },
     ],
   },
]

const diagnosticoTriagemMedidas = [
  {
    id: 1,
    label: `15) Recebeu triagem para disfagia dentro de 24 horas após a chegada na instituição`,
    name: 'disfagia_avc',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
      {
        id: 3,
        descricao:
          'Não foi possível realizar por limitação clínica \n (ex.: coma, redução do sensório, ventilação \n assistida, etc)',
        value: '98',
      },
    ],
  },
];

const medidasDeConforto = [
  {
    id: 1,
    label: `16) Paciente em medidas de conforto ou cuidados paliativos`,
    name: 'paliativos_avc',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];

const covidAvc = [
  {
    id: 1,
    label: '19) Paciente teve diagnóstico de COVID-19 durante a internação',
    name: 'covid_avc',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
      {
        id: 3,
        descricao:
          'Não testado',
        value: '2',
      },
    ],
  },
]

const dadosSaida = [
  {
    id: 1,
    label: '17) Recebeu prescrição de antiagregante na alta',
    name: 'antiagregante_avc',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
      {
        id: 3,
        descricao:
          'Não recebeu pois estava com limitação terapêutica instituída, teve alta para outra instituição ou apresentava contraindicação ao uso de antiagregante',
        value: '98',
      },
    ],
  },
];

const recebeuAnticoagulante = [
  {
    id: 1,
    label: '18) Recebeu prescrição de anticoagulante na alta',
    name: 'anticoagulante_avc',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
      {
        id: 3,
        descricao:
          'Não recebeu pois estava com limitação terapêutica instituída, teve alta para outra instituição ou apresentava contraindicação ao uso de anticoagulante',
        value: '98',
      },
    ],
  },
];

const saidaMotivo = [
  {
    id: 1,
    label: '20) Motivo da saída hospitalar',
    name: 'saida_motivo_avc',
    opcoes: [
      {
        id: 1,
        descricao: 'Alta médica',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Óbito',
        value: '2',
      },
      {
        id: 3,
        descricao: 'Transferência',
        value: '3',
      },
      {
        id: 4,
        descricao: 'Evasão',
        value: '4',
      },
    ],
  },
]

const causaObito = [
  {
    id: 1,
    label: `21) Causa direta do óbito`,
    name: 'obito_causa_avc',
    opcoes: [
      {
        id: 1,
        descricao: 'Evolução do AVC (ex. morte encefálica)',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Infarto Agudo do Miocárdio',
        value: '2',
      },
      {
        id: 3,
        descricao: 'Embolia pulmonar',
        value: '3',
      },
      {
        id: 4,
        descricao: 'Sepse',
        value: '4',
      },
      {
        id: 5,
        descricao: 'Outro',
        value: '98',
      },
    ],
  },
]

const seguimento = [
  {
    id: 1,
    label: '23) Pontuação no escore de Rankin modificado em 90 dias após o AVC',
    name: 'rankin_avc',
    opcoes: [
      {
        id: 1,
        descricao: '0 - Nenhuma sequela',
        value: '0',
      },
      {
        id: 2,
        descricao: '1 - Nenhuma incapacidade significativa, a despeito dos sintomas ',
        value: '1',
      },
      {
        id: 3,
        descricao:
          '2 - Leve incapacidade, incapaz de realizar todas as atividades prévias, porém é independente para os cuidados pessoais',
        value: '2',
      },
      {
        id: 4,
        descricao:
          '3 - Incapacidade moderada; requer alguma ajuda, mas é capaz de caminhar sem assistência (pode usar bengala ou andador)',
        value: '3',
      },
      {
        id: 5,
        descricao:
          '4 - Incapacidade moderadamente severa; incapaz de caminhar sem assistência',
        value: '4',
      },
      {
        id: 6,
        descricao: '5 - Deficiência grave; requer cuidados e atenção constante',
        value: '5',
      },
      {
        id: 7,
        descricao: '6 - Óbito',
        value: '6',
      },
      {
        id: 8,
        descricao: 'Não realizado',
        value: '99',
      },
    ],
  },
];

export {
  conveniosPaciente,
  tiposDeAvc,
  examesDeImagem,
  tempoInicioSintomas,
  chegadaEmergencia,
  atendimentoDuranteInternacao,
  tratamentoReperfusao,
  diagnosticoTriagemMedidas,
  medidasDeConforto,
  dadosSaida,
  recebeuAnticoagulante,
  covidAvc,
  saidaMotivo,
  causaObito,
  flutterAtrial,
  saidaEmergencia,
  seguimento,
  tromboliseIntravenosa,
  trombectomia,
};
